var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col rounded-xl bg-white p-6"},[_c('h5',{staticClass:"border-b border-truegray-300 w-full pb-2"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"flex flex-col flex-grow items-center justify-around",class:_vm.contentClasses},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }